module.exports = __webpack_public_path__ + "ddf0a2bfd394e81a2a9724158e7bf6ac.fbx";